export default "__VITE_ASSET__OkbHTI9e__"